import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import './AdminDashboard.css';

interface Stats {
  totalProducts: number;
  totalOrders: number;
  pendingOrders: number;
  completedOrders: number;
  totalRevenue: string;
}

const AdminDashboard: React.FC = () => {
  const [stats, setStats] = useState<Stats | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await api.get('/admin/stats');
      setStats(response.data.stats);
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container">
        <div className="loading">Loading admin dashboard...</div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="admin-header">
        <h1>Admin Dashboard</h1>
        <p>Manage products and orders</p>
      </div>

      <div className="admin-stats-grid">
        <div className="stat-card">
          <div className="stat-icon">📦</div>
          <div className="stat-value">{stats?.totalProducts || 0}</div>
          <div className="stat-label">Total Products</div>
          <Link to="/admin/products" className="stat-link">Manage Products →</Link>
        </div>

        <div className="stat-card">
          <div className="stat-icon">📋</div>
          <div className="stat-value">{stats?.totalOrders || 0}</div>
          <div className="stat-label">Total Orders</div>
          <Link to="/admin/orders" className="stat-link">View Orders →</Link>
        </div>

        <div className="stat-card">
          <div className="stat-icon">⏳</div>
          <div className="stat-value">{stats?.pendingOrders || 0}</div>
          <div className="stat-label">Pending Orders</div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">✅</div>
          <div className="stat-value">{stats?.completedOrders || 0}</div>
          <div className="stat-label">Completed Orders</div>
        </div>

        <div className="stat-card revenue-card">
          <div className="stat-icon">💰</div>
          <div className="stat-value">${stats?.totalRevenue || '0.00'}</div>
          <div className="stat-label">Total Revenue</div>
        </div>
      </div>

      <div className="admin-actions">
        <Link to="/admin/products" className="admin-action-card">
          <h3>Manage Products</h3>
          <p>Add, edit, or delete products</p>
        </Link>
        <Link to="/admin/orders" className="admin-action-card">
          <h3>Manage Orders</h3>
          <p>View and update order status</p>
        </Link>
        <Link to="/admin/membership-plans" className="admin-action-card">
          <h3>Membership Plans</h3>
          <p>Configure deposits, discounts, and benefits</p>
        </Link>
        <Link to="/admin/wallets" className="admin-action-card">
          <h3>Wallet Manager</h3>
          <p>Top up or adjust member wallets</p>
        </Link>
      </div>
    </div>
  );
};

export default AdminDashboard;
